import branch from 'recompose/branch';
import renderNothing from 'recompose/renderNothing';
import withHandlers from 'recompose/withHandlers';
import { connect } from 'react-redux';
import compose from 'recompose/compose';

import {
  brandOrCategorySelected,
  getSelectedBrand,
  getSelectedCategory,
} from '../selectors';
import { resetProductBrand, resetProductCategory } from '../actions';
import * as categoriesSelectors from '../../../products/categories/selectors';
import * as brandsSelectors from '../../../products/brands/selectors';
import ProductNavigation from '../components/ProductNavigation';

const ProductNavigationContainer = compose(
  connect(
    state => ({
      categoryName: categoriesSelectors.getName(state, getSelectedCategory(state)),
      brandName: brandsSelectors.getName(state, getSelectedBrand(state)),
      hasFilters: brandOrCategorySelected(state),
    }),
    { resetProductCategory, resetProductBrand }
  ),
  withHandlers({
    resetFilters: props => () => {
      props.resetProductBrand();
      return props.resetProductCategory();
    },
  }),
  branch(
    props => !props.hasFilters,
    renderNothing,
  )
)(ProductNavigation);

export default ProductNavigationContainer;
